import Editor from './components/Editor'
import * as reportTemplateEditorsActions from './actions'
import reportTemplateEditorsReducer from './reducers'
import * as reportTemplateEditorsSelectors from './selectors'

export { reportTemplateEditorsActions, reportTemplateEditorsReducer, reportTemplateEditorsSelectors }

export default Editor
